import type { CaseStatus } from "@/api";
import { stageOf, stageText } from "@/lib/stages";

import styles from "./Stages.module.css";

/**
 * The stage as one neutral word. Deliberately not in a status colour: the
 * five `--st-*` colours mean „bestätigt / automatisch / prüfen / Widerspruch /
 * unbemaßt" (PRD §18.2) — a Vorgang „In Kalkulation" is none of those. The
 * start list made the same call (design 2026-09-07).
 */
export function StageChip({ status }: { status: CaseStatus }) {
  return <span className={styles.chip}>{stageText(stageOf(status))}</span>;
}
